import React from 'react'
import card1 from '../assets/servicesImages/appdev/card1.1.png'
import card2 from '../assets/servicesImages/appdev/card2.1.png'
import card3 from '../assets/servicesImages/appdev/card3.1.png'

const cards = [
    {
        image: card1,
        title: 'Android Application Development',
        desc: "We've built over Various Android apps in a variety of categories, including on-demand, health & Live-streaming, and other popular categories. We build Android apps from the ground up using Java and Kotlin for anything."
    },
    {
        image: card2,
        title: 'iOS Application Development',
        desc: "To include high-end iPhone app development services, we use modern programming languages such as Swift and Objective-C. We've developed iPhone applications in a variety of categories using tried-and-true technologies and methods."
    },
    {
        image: card3,
        title: 'Hybrid Application Development',
        desc: "Hybrid mobile applications are those that use the same code to work on a variety of mobile devices, such as iOS and Android. Many companies prefer hybrid apps because they are more flexible."
    }
]

const AppDevSection2 = () => {
    return (
        <div className='flex flex-col gap-[48px] px-6 sm:px-8 md:px-12 lg:px-32 mb-12'>
            <div className='text-center'>
                <p className='text-3xl font-semibold font-nunito'>Our Field of Specialization</p>
                <p className='font-nunito text-lg font-medium text-gray-700 mt-4 max-w-3xl mx-auto'>
                    We provide a wide range of mobile app development services that benefit the businesses and organizations we collaborate with. Our dedicated team of mobile app developers is committed to delivering high-quality apps tailored to various business needs. The following programs are our specialties:
                </p>
            </div>

            <div className="flex flex-wrap justify-center gap-6 px-4">
  {cards.map((c, index) => (
    <div
      key={index}
      className="group w-full sm:w-[300px] md:w-[350px] bg-white p-4 rounded-xl flex flex-col items-center gap-3 hover:scale-[1.03] hover:shadow-2xl transition-all duration-300"
    >
      <img
        src={c.image}
        alt={c.title}
        className="h-44 w-full object-cover rounded-md transition-transform duration-300 group-hover:scale-110"
      />
      <p className="font-bold text-lg text-center group-hover:text-blue-800 transition-colors duration-300">
        {c.title}
      </p>
      <p className="text-sm text-center">{c.desc}</p>
    </div>
  ))}
</div>

                    {/* <div key={index} className='bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300'>
                        <img src={c.image} alt={c.title} className='w-full h-56 object-cover rounded-lg mb-6' />
                        <p className='text-xl font-semibold font-nunito text-center text-gray-900 mb-4'>{c.title}</p>
                        <p className='text-base font-normal text-gray-600 leading-[1.6] text-justify'>
                            {c.desc}
                        </p>
                    </div>
                ))}
            </div> */}
          
        </div>
    )
}

export default AppDevSection2
